exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".explore-option-icon{display:block;margin-right:2em;padding-bottom:0;height:100px;width:auto;max-width:75%}@supports (display: grid){.explore-option-icon{display:block;margin-right:2em;padding-bottom:0;height:100px;width:auto;max-width:100%}}\n", ""]);
